import { z } from 'zod';

import { RegisterProductFieldsSchema } from './register-product.schemas.js';

export const UpdateProductBodySchema = RegisterProductFieldsSchema.partial()
  .extend({
    categoryId: z.uuid().nullable().optional(),
    productTypeId: z.uuid().nullable().optional(),
    brandId: z.uuid().nullable().optional(),
    manufacturerId: z.uuid().nullable().optional(),
    catalogManufacturerId: z.uuid().nullable().optional(),
    measurementUnitId: z.uuid().nullable().optional(),
    catalogMeasurementUnitId: z.uuid().nullable().optional(),
    sku: z.string().trim().max(50).nullable().optional(),
    manufacturerCode: z.string().trim().max(100).nullable().optional(),
    packageBarcode: z.string().trim().max(100).nullable().optional(),
    unitBarcode: z.string().trim().max(100).nullable().optional(),
    qrCode: z.string().trim().max(100).nullable().optional(),
    grossWeightGrams: z.number().int().nonnegative().nullable().optional(),
    netWeightGrams: z.number().int().nonnegative().nullable().optional(),
    usefulLifeMeters: z.number().int().nonnegative().nullable().optional(),
    usefulLifeMonths: z.number().int().nonnegative().nullable().optional(),
    alertMeters: z.number().int().nonnegative().nullable().optional(),
    alertMonths: z.number().int().nonnegative().nullable().optional(),
    warrantyMonths: z.number().int().nonnegative().nullable().optional(),
    warrantyMeters: z.number().int().nonnegative().nullable().optional(),
    warrantyTerms: z.string().trim().max(5000).nullable().optional(),
    notes: z.string().trim().max(5000).nullable().optional(),
  })
  .refine((body) => Object.keys(body).length > 0, { message: 'At least one field is required' })
  .refine((body) => !(body.manufacturerId != null && body.catalogManufacturerId != null), {
    message: 'manufacturer ref is exclusive',
  })
  .refine((body) => !(body.measurementUnitId != null && body.catalogMeasurementUnitId != null), {
    message: 'measurement unit ref is exclusive',
  });

export type UpdateProductBody = z.infer<typeof UpdateProductBodySchema>;
